/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `unpublished` - Unpublished
* `publishing` - Publishing
* `published` - Published
* `edited` - Edited
* `failed` - Failed
 */
export type CompanyReportStatusEnum = typeof CompanyReportStatusEnum[keyof typeof CompanyReportStatusEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyReportStatusEnum = {
  unpublished: 'unpublished',
  publishing: 'publishing',
  published: 'published',
  edited: 'edited',
  failed: 'failed',
} as const;
